// ** React Imports
import { Outlet } from 'react-router-dom'
import { useState, useEffect } from 'react'

// ** Core Layout Import
// !Do not remove the Layout import
import Layout from '@layouts/VerticalLayout'

// ** Menu Items Array
import adminNavigation from '@src/navigation/vertical/admin'
import operatorNavigation from '@src/navigation/vertical/operator'

const VerticalLayout = props => {
  const [menuData, setMenuData] = useState([])

  // ** Get navigation based on user role
  useEffect(() => {
    const getUserNavigation = () => {
      try {
        const userData = JSON.parse(localStorage.getItem('userData'))
        
        if (userData?.roleType === 'BUS_OPERATOR') {
          return operatorNavigation
        }
        
        return adminNavigation
      } catch {
        return adminNavigation
      }
    }

    setMenuData(getUserNavigation())
    
    // Listen for storage changes to update navigation when user logs in/out
    const handleStorageChange = () => {
      setMenuData(getUserNavigation())
    }
    
    window.addEventListener('storage', handleStorageChange)
    
    return () => {
      window.removeEventListener('storage', handleStorageChange)
    }
  }, [])

  return (
    <Layout menuData={menuData} {...props}>
      <Outlet />
    </Layout>
  )
}

export default VerticalLayout
